import { apiRequest } from '@/shared/api';

import type { DailyActivity } from '../model/types';

export function fetchDailyActivity(): Promise<DailyActivity> {
  return apiRequest<DailyActivity>('/community/daily-activity');
}
